var _metadata, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHair6FrontShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 30 45",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(32,28,45,0.8313725490196079)",
    d: "M12 10h2M16 10h3M11 11h1M10 12h1M20 12h1M9 13h1M21 13h1M9 14h1M21 14h1M9 15h1M21 15h1M9 16h1M11 16h1M19 16h1M9 17h1M11 17h1M19 17h1M9 18h1M11 18h1M19 18h1M9 19h1M11 19h1M19 19h1M9 20h1M11 20h1M17 20h1M19 20h1M9 21h1M11 21h2M17 21h1M9 22h1M11 22h1M17 22h1M9 23h1M17 23h1M9 24h1M17 24h1M10 25h1M18 25h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(31,28,43,0.5764705882352941)",
    d: "M14 10h2M20 13h1M17 15h1M17 16h1M10 17h1M17 18h1M17 19h1M19 22h1M11 23h1M19 23h1M11 24h1M19 24h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(30,26,43,0.23137254901960785)",
    d: "M12 11h2M15 11h3M19 12h1M18 14h1M10 15h1M12 15h1M15 15h1M19 15h2M10 16h1M13 16h4M18 16h1M20 16h1M15 17h3M10 18h1M18 18h1M10 20h1M10 23h1M18 23h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(33,28,44,0.6745098039215687)",
    d: "M18 11h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(32,28,44,0.9294117647058824)",
    d: "M19 11h1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair6FrontShadow);
export default __webpack_public_path__ + "static/media/hair6-front-shadow.b6859baa1a9faf5b1b283f31e0aa3f14.svg";
export { ForwardRef as ReactComponent };